import { ProviderDate } from '@bagonboard/ui-kit';
import moment from 'moment';

export const parse = data => data.map(({ flight }) => {
  const { flightData } = flight;
  const { origin, destination } = flightData;
  const departureMoment = ProviderDate.utcTimezone(moment.utc(origin.dateUtc), origin.timezone);
  const arrivalMoment = ProviderDate.utcTimezone(moment.utc(destination.dateUtc), destination.timezone);

  return {
    airline     : flightData.companyOrigin,
    operator    : flightData.operator,
    flightNumber: flightData.flight,
    segments    : flightData.airportSegments.join(' / '),
    departure   : {
      date: departureMoment.format('DD/MM/YYYY'),
      hour: departureMoment.format('HH:mm'),
    },
    arrival: {
      date: arrivalMoment.format('DD/MM/YYYY'),
      hour: arrivalMoment.format('HH:mm'),
    },
  };
});
